import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './components/shared/page-not-found/page-not-found.component';
import { LoginContainerComponent } from './components/login-container/login-container.component';
import { HelpComponent } from './components/help/help.component';
import { FaqComponent } from './components/faq/faq.component';
import { InsuredAcknowledgementComponent } from '../../../coverpath-common/angular/components/acknowledgement/acknowledgement.component';
import { AccountCenterDetailedViewComponent } from '../../../coverpath-common/angular/components/account-center/detailed-view/account-center-detailed-view.component';
import { AccountCenterResolver } from '../../../coverpath-common/angular/services/account-center/account-center-resolver.service';
import { ApplicationFormComponent } from '../../../coverpath-common/angular/components/application-form/application-form.component';
import { AccountSettingsComponent } from '../../../coverpath-common/angular/components/account-settings/account-settings.component';
import { ApplicationFormGuard } from './services/navguard/application-form.navguard';
import { LoadingComponent } from '../../../coverpath-common/angular/components/shared/loading/loading.component';
import { AuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AuthenticationResolver';
import { Auth0CallbackComponent } from '../../../coverpath-common/angular/services/authentication/auth0callback.component';
import { SignCompleteComponent } from './components/sign-complete/sign-complete.component';

import { ValidAdvisorLinkGuard } from './services/navguard/valid-advisor-link.navguard';
import { AuthGuard } from './services/navguard/auth.navguard';
import { ActiveApplicationListGuard } from './services/navguard/active-application-list.navguard';
import { RedirectOnlyGuard } from './services/navguard/redirect-only.navguard';
import { Auth0Guard } from '../../../coverpath-common/angular/navguards/Auth0Guard';
import { PoliciesOverviewComponent } from '../../../coverpath-common/angular/components/account-center/overview/policies-overview.component';
import { IndividualApplicationAccessGuard } from '../../../coverpath-common/angular/navguards/IndividualApplicationAccessGuard';
import { CoverpathLogoutComponent } from './components/logout/coverpath-logout.component';
import { AMCAuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AMCAuthenticationResolver';
import { ConcurrentModificationComponent } from './components/concurrentmodification/concurrentmodification.component';
import { InsuredEsignComponent } from './components/esign/insured-esign.component';
import { SignatureRedirectComponent } from './components/signature-redirect/signature-redirect.component';
import { AdditionalEsignComponent } from './components/esign/annuity/additional-esign.component';
import { CommonRoutes } from '../../../coverpath-common/angular/services/authentication/auth0.service';
import { ViewDocumentsComponent } from './components/view-documents/view-documents.component';
import { UnauthorizedComponent } from '../../../coverpath-common/angular/components/unauthorized/unauthorized.component';
import { ActiveApplicationGuard } from '../../../coverpath-common/js/services/auth-guard/active-application.navguard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'home',
    component: HomeComponent,
    resolve: {
      authenticationData: AuthenticationResolver,
    },
    canActivate: [ValidAdvisorLinkGuard],
  },
  {
    path: 'login',
    component: LoginContainerComponent,
    resolve: { authenticationData: AuthenticationResolver },
    canActivate: [Auth0Guard],
  },
  { path: 'help', component: HelpComponent, resolve: { authenticationData: AuthenticationResolver } },
  {
    path: 'invalid-link',
    component: HelpComponent,
    resolve: { authenticationData: AuthenticationResolver },
    canActivate: [RedirectOnlyGuard],
  },
  {
    path: CommonRoutes.INVALID_EMAIL,
    component: HelpComponent,
    resolve: { authenticationData: AuthenticationResolver },
    canActivate: [RedirectOnlyGuard],
  },
  {
    path: 'draft-in-progress',
    component: HelpComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  { path: 'faq', component: FaqComponent, resolve: { authenticationData: AuthenticationResolver } },
  {
    path: 'acknowledgement',
    component: InsuredAcknowledgementComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'esign',
    component: InsuredEsignComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'view-documents',
    component: ViewDocumentsComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'annuity-additional-esign',
    component: AdditionalEsignComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'signature-redirect/application/:applicationNumber',
    component: SignatureRedirectComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'application-form',
    component: ApplicationFormComponent,
    canActivate: [AuthGuard, ActiveApplicationGuard, ApplicationFormGuard],
    resolve: { authenticationData: AMCAuthenticationResolver },
  },
  {
    path: 'account-center',
    component: PoliciesOverviewComponent,
    canActivate: [AuthGuard, ActiveApplicationListGuard],
  },
  {
    path: 'account-center-detailed-view',
    component: AccountCenterDetailedViewComponent,
    canActivate: [AuthGuard, IndividualApplicationAccessGuard, ActiveApplicationGuard],
    resolve: {
      actionString: AccountCenterResolver,
    },
  },
  { path: 'settings', component: AccountSettingsComponent, canActivate: [AuthGuard] },
  { path: 'loading', component: LoadingComponent },
  { path: 'sign-complete', component: SignCompleteComponent, resolve: { authenticationData: AuthenticationResolver } },
  {
    path: 'auth0callback/:client',
    component: Auth0CallbackComponent,
    resolve: { authenticationData: AuthenticationResolver },
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    resolve: { authenticationData: AuthenticationResolver },
    canActivate: [AuthGuard, RedirectOnlyGuard],
  },
  {
    path: 'concurrent-modification',
    component: ConcurrentModificationComponent,
    resolve: { authenticationData: AuthenticationResolver },
    canActivate: [AuthGuard],
  },
  { path: 'logout', component: CoverpathLogoutComponent, canActivate: [AuthGuard] },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: [AccountCenterResolver, Auth0CallbackComponent, AuthenticationResolver],
})
export class AppRoutingModule {}
